import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ChatService } from '@app/services'
import MainConfig from '../../../../../config/main'

@Component({
    selector: 'app-chat-frame',
    templateUrl: './chat-frame.component.html',
    styleUrls: ['./chat-frame.component.css'],
})
export class ChatFrameComponent implements OnInit, OnDestroy {
    @Input() communicationId: string
    @Input() isPatient = false
    @Input() styleName: string
    public enableReply: boolean

    constructor(public chatService: ChatService) {
        this.enableReply = MainConfig.ENABLE_CHAT_REPLY
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this.chatService.replies = []
    }

    onReact(event: any, replyId) {
        this.chatService.updateReplyReaction(replyId, event)
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/modal-commons/chat-frame/chat-frame.component.ts